import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { DealerPartNumberResultsRoute } from "../../../navigation/DealerRoutes";
import { useRouteParams } from "../../../navigation/useRouteParams";
import { useSearchForm } from "../../../stores/hooks/useSearchForm";
import { Input } from "../../../ui/Input/Input";
import { PartNumberIcon } from "../../../ui/icons/PartNumberIcon";

export const PartNuberInput: FunctionComponent = () => {
  const { t } = useTranslation();
  const params = useRouteParams(DealerPartNumberResultsRoute);
  const [{ partNumber }, { setPartNumber }] = useSearchForm();

  return (
    <Input
      onChange={(event): void => {
        setPartNumber(event.target.value);
      }}
      aria-label="partNumber"
      before={<PartNumberIcon />}
      defaultValue={(partNumber || params?.partNumber) ?? ""}
      name="partNumber"
      placeholder={t("searchForm.enterPartNumber")}
    />
  );
};
